import { getCookie, setCookie, deleteCookie, } from './cookies';
// Cookie name for admin JWT token during impersonation
export const ADMIN_JWT_COOKIE_NAME = 'th_admin_jwt';
/**
 * Set admin JWT token cookie for impersonation
 * @param token - Admin JWT token
 * @param options - Optional cookie options
 * @param context - Server-side context for setting headers
 */
export function setAdminJWTCookie(token, options, context) {
    const rootDomain = import.meta.env.VITE_ROOT_DOMAIN;
    const cookieOptions = {
        ...(rootDomain ? { domain: rootDomain } : {}),
        sameSite: 'lax',
        maxAge: 60 * 60, // 60 minutes
        path: '/',
        ...options,
    };
    setCookie(ADMIN_JWT_COOKIE_NAME, token, cookieOptions, context);
}
/**
 * Get admin JWT token cookie
 * @param context - Server-side context for reading request
 * @returns The admin JWT token or undefined
 */
export function getAdminJWTCookie(context) {
    return getCookie(ADMIN_JWT_COOKIE_NAME, context);
}
/**
 * Delete admin JWT token cookie
 * @param options - Cookie options (path, domain)
 * @param context - Server-side context for setting headers
 */
export function deleteAdminJWTCookie(options, context) {
    const rootDomain = import.meta.env.VITE_ROOT_DOMAIN;
    const deleteOptions = {
        ...(rootDomain ? { domain: rootDomain } : {}),
        path: '/',
        ...options,
    };
    deleteCookie(ADMIN_JWT_COOKIE_NAME, deleteOptions, context);
}
//# sourceMappingURL=adminAuth.js.map